import { initSlider } from './init-slider';
import Masonry from 'masonry-layout';

const $win = $(window);
const targetNode = document.getElementById('insta-feed');
const config = { childList: true };
let flag;

if (targetNode !== null) {
  function initInstaFeedSlider() {
    const instaFeedSliderOptions = {
      infinite: true,
      //autoplay: true,
      arrows: false,
      dots: true,
      speed: 300,
      autoplaySpeed: 5000,
      slidesToShow: 1
    };

    initSlider($('.insta-feed-slider'), instaFeedSliderOptions);
  }

  const callback = function(mutationsList) {
    if ($(targetNode).find('a').length) {
      clearTimeout(flag);

      flag = setTimeout(function() {
        observer.disconnect();

        if ($(targetNode).hasClass('insta-feed-slider')) {
          $('.insta-feed-slider a').wrap('<div class="insta-feed-slide"></div>');
          $('.insta-feed-slider .insta-feed-slide:nth-child(n+7)').remove();

          if ($win.width() < 768) {
            initInstaFeedSlider();
          }

          $win.on('resize', function() {
            if ($win.width() < 768) {
              if (!$('.insta-feed-slider').hasClass('slick-initialized')) {
                initInstaFeedSlider();
              }
            } else {
              if ($('.insta-feed-slider').hasClass('slick-initialized')) {
                $('.insta-feed-slider').slick('unslick');
              }
            }
          });
        }

        if ($(targetNode).hasClass('insta-feed-blocks')) {
          $('.insta-feed-blocks a').wrap('<div class="insta-feed-block"></div>');

          $('.insta-feed-blocks .insta-feed-block').each(function() {
            $(this).addClass(`insta-feed-block--size-${Math.floor(Math.random() * 8) + 1}`);
          });

          const grid = document.querySelector('.js-masonry');
          const msnry = new Masonry(grid, {});
          msnry.layout();
        }
      }, 1000);
    }
  };

  let observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
}



// WEBPACK FOOTER //
// ./../src/assets/js/insta-feed.js